import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  getServiceRequestItemById,
  pagingHistoryServiceRequestItem,
  pagingServiceRequestItemByPatientServiceRegisterInfo,
  pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate,
  updateServiceAllocationInfo,
  updateTourInfo,
  voidedServiceRequestItemFromPatientServiceRegister,
} from "app/services/ServiceRequestItemService";
import { getFileById } from "app/services/FileDescriptionExtService";
export default class ServiceRequestItemStore {
  intactSearchObject = {
    ...new SearchObject(),
    // orderDateFrom: new Date(new Date().getFullYear(), 0, 1), // Thời gian chỉ định từ
    // orderDateTo: new Date(), // Thời gian chỉ định đến
    performDateFrom: null, // Thời gian thực hiện từ
    performDateTo: null, // Thời gian thực hiện đến
    roomId: null, // Phòng thực hiện
    departmentId: null, // Cơ sở thực hiện
    itemStatus: null,
    healthCareSvId: null, //id cua dich vu
    getReport: true,
  };

  selectedServiceRequestItem = null;
  searchObject = JSON.parse(JSON.stringify(this.intactSearchObject));
  openConfirmDeleteNewServiceRequestItem = false;
  pageServiceRequestItem = new PageResponse();
  initDataTreatmentResultPopup = null;
  openTreatmentResultPopup = false;
  allocationServiceInfo = false;
  openUpdateTourInfo = false;
  listSelectedItem = [];
  // resetSlected = false;
  openPrintTreatmentPopup = false;
  openConfirmMessage = null;
  openConfirmError = null;
  permissionErrorMessage = null;

  handleCloseErrorMessage = () => {
    this.permissionErrorMessage = null;
    this.openConfirmMessage = null;
  };

  searchHistory = new SearchObject();
  pageHistoryServiceRequestItem = null;
  openPopupHistory = false;
  constructor() {
    makeAutoObservable(this);
  }

  pagingHistoryServiceRequestItem = async (id) => {
    const payload = {
      ...this.searchHistory,
      id,
    };
    this.openPopupHistory = true;
    return await pagingHistoryServiceRequestItem(payload)
      .then(({ data }) => {
        this.pageHistoryServiceRequestItem = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu lịch sử khách hàng có lỗi");
      });
  };
  handleCloseHistoryPopup = () => {
    this.openPopupHistory = false;
    this.pageHistoryServiceRequestItem = null;
  };

  handleChangeFormSearchHistory = (searchHistory) => {
    this.searchHistory = {
      ...this.searchHistory,
      ...searchHistory,
    };
    this.pagingHistoryServiceRequestItem();
  };

  pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate = async () => {
    const payload = {
      ...this.searchObject,
    };

    return await pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate(
      payload,
    )
      .then(({ data }) => {
        this.pageServiceRequestItem = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu tư vấn khách hàng có lỗi");
      });
  };

  setSelectedItem = (list) => {
    this.listSelectedItem = list;
  };

  resetSlected = () => {
    this.listSelectedItem = [];
  };

  handleSetSearchObject = (searchObject) => {
    if (searchObject.room == null) {
      searchObject.roomId = null;
    } else {
      searchObject.roomId = searchObject.room.id;
    }

    if (searchObject.department == null) {
      searchObject.departmentId = null;
    } else {
      searchObject.departmentId = searchObject.department.id;
    }

    if (searchObject.healthCareSv == null) {
      searchObject.healthCareSvId = null;
    } else {
      searchObject.healthCareSvId = searchObject.healthCareSv.id;
    }

    this.searchObject = { ...searchObject };
  };

  setPageIndex = async (page) => {
    this.searchObject.pageIndex = page;

    await this.pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate();
  };

  setPageSize = async (value) => {
    this.searchObject.pageSize = value;
    this.searchObject.pageIndex = 1;

    await this.pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate();
  };

  handleChangePage = async (newPage) => {
    await this.setPageIndex(newPage);
  };

  handleClose = () => {
    this.openConfirmDeleteNewServiceRequestItem = false;
    this.selectedServiceRequestItem = null;
    this.allocationServiceInfo = null;
    this.openUpdateTourInfo = false;
    this.permissionErrorMessage = null;
    this.openConfirmMessage = null;
    this.openConfirmError = null;
  };

  handleDeleteNewServiceRequestItem = (item) => {
    this.selectedServiceRequestItem = {
      ...item,
    };

    this.openConfirmDeleteNewServiceRequestItem = true;
  };

  handleConfirmDeleteNewServiceRequestItem = async () => {
    if (!this.selectedServiceRequestItem?.id) {
      toast.error("Không có chỉ định dịch vụ nào được chọn để xóa.");
      return;
    }

    try {
      // Call the API to delete the service request item
      // Assuming there's a function deleteServiceRequestItem that takes an ID
      const { data } = await voidedServiceRequestItemFromPatientServiceRegister(
        this.selectedServiceRequestItem?.id,
      );

      if (data && data.responseStatus === false) {
        setTimeout(() => {
          if (data.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data.responseDetail;
          } else {
            this.openConfirmMessage = data.responseDetail || "Xóa chỉ định dịch vụ thất bại.";
          }
        }, 500);
        return;
      }

      toast.success("Xóa chỉ định dịch vụ thành công.");

      this.openConfirmDeleteNewServiceRequestItem = false;
      this.selectedServiceRequestItem = null;

      // Refresh the list after deletion
      await this.pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate();
    } catch (error) {
      console.error(error);
      let message = "Xóa chỉ định dịch vụ thất bại.";
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (typeof error?.response?.data === "string" && error.response.data) {
        message = error.response.data;
      } else if (error?.message) {
        message = error.message;
      }
      toast.error(message);
    }
  };

  handleOpenTreatmentResultPopup = async (row) => {
    let imagesAfterTreatment = row?.diagnosticReport?.imagesAfterTreatment;
    let imagesBeforeTreatment = row?.diagnosticReport?.imagesBeforeTreatment;
    // console.log("imagesAfterTreatment", imagesAfterTreatment);
    if (imagesAfterTreatment) {
      await Promise.all(
        imagesAfterTreatment.map(async (item, index) => {
          const fileId = item?.fileDescription?.id;

          if (!fileId) return;

          try {
            const { data: fileData } = await getFileById(fileId);
            if (fileData instanceof Blob) {
              imagesAfterTreatment[index].fileDescription = {
                ...imagesAfterTreatment[index].fileDescription,
                fileData: URL.createObjectURL(fileData),
              };
            }
          } catch (error) {
            console.error(error);
          }
        }),
      );
    }

    if (imagesBeforeTreatment) {
      await Promise.all(
        imagesBeforeTreatment.map(async (item, index) => {
          const fileId = item?.fileDescription?.id;

          if (!fileId) return;

          try {
            const { data: fileData } = await getFileById(fileId);
            if (fileData instanceof Blob) {
              imagesBeforeTreatment[index].fileDescription = {
                ...imagesBeforeTreatment[index].fileDescription,
                fileData: URL.createObjectURL(fileData),
              };
            }
          } catch (error) {
            console.error(error);
          }
        }),
      );
    }
    this.openTreatmentResultPopup = true;
    this.initDataTreatmentResultPopup = {
      ...row,
      diagnosticReport: {
        ...row?.diagnosticReport,
        imagesAfterTreatment,
        imagesBeforeTreatment,
      },
    };
  };

  handleCloseTreatmentResultPopup = () => {
    this.openTreatmentResultPopup = false;
    this.initDataTreatmentResultPopup = null;
  };

  handleOpenAllocationServicePopup = async (serviceRequestItemId) => {
    try {
      const { data } = await getServiceRequestItemById(serviceRequestItemId);

      this.allocationServiceInfo = {
        ...data,
      };
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu chỉ định");
    }
  };

  handleUpdateServiceAllocationInfo = async (values) => {
    try {
      const { data } = await updateServiceAllocationInfo({
        ...values,
        isHisCreate: true,
      });

      if (data?.responseStatus === false) {
        setTimeout(() => {
          if (data?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.responseDetail;
          } else {
            this.openConfirmMessage = data?.responseDetail || "Cập nhật chỉ định thất bại!";
          }
        }, 500);
        return data;
      } else {
        this.handleClose();
        toast.success("Đã cập nhật chỉ định thành công");
        return data;
      }
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi cập nhật chỉ định, vui lòng thử lại sau");
    }
  };

  handleOpenUpdateTourInfo = async (serviceRequestItemId) => {
    try {
      const { data } = await getServiceRequestItemById(serviceRequestItemId);

      this.selectedServiceRequestItem = {
        ...data,
      };

      this.openUpdateTourInfo = true;

      return data;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu chia Tour");
    }
  };

  handleUpdateTourInfo = async (values) => {
    try {
      const { data } = await updateTourInfo(values);

      if (data && data.responseStatus === false) {
        setTimeout(() => {
          if (data?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.responseDetail;
          } else {
            this.openConfirmMessage = data.responseDetail || "Cập nhật dữ liệu chia Tour thất bại!";
          }
        }, 500);
        return data;
      }

      toast.success("Cập nhật thông tin chia Tour của điều trị thành công!");

      return data;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi cập nhật dữ liệu chia Tour");
    }
  };
  handleOpenPrintTreatmentPopup = () => {
    this.openPrintTreatmentPopup = true;
  };
  handleClosePrintTreatmentPopup = () => {
    this.openPrintTreatmentPopup = false;
  };

  handleCloseConfirmMessage = () => {
    this.openConfirmMessage = null;
  };

  handleSetConfirmError = (mess) => {
    this.openConfirmError = mess;
  };
  handleCloseConfirmError = () => {
    this.openConfirmError = null;
  };
  resetStore = () => {
    this.searchObject = {
      ...this.intactSearchObject,
    };
    this.pageServiceRequestItem = new PageResponse();
    this.openConfirmDeleteNewServiceRequestItem = false;
    this.allocationServiceInfo = null;
    this.openUpdateTourInfo = false;
    this.openConfirmMessage = null;
    this.openConfirmError = null;
    this.permissionErrorMessage = null;
  };
}
